import { Header, Table } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledTable = styled(Table)`
.disabled {
  background: white;
}
`
export const StyledHeader = styled(Header)`
font-size: 18px !important;
`
export const ModalTextHeader = styled.div`
font-size: 20px !important;
`
export const TableFooterWrapper = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
`